import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import "../report-styles/infoBarSelection.scss";

const formatSelections = (selections, options) => {
  if (selections.length === 1)
    return options.find((e) => e.id === selections[0])?.name;
  else return `${selections.length} Selected`;
};

const InfoBarSelection = ({ item, values, type, isRequired }) => {
  // console.log(values);
  return (
    <div
      className="info-bar-selection-container"
      style={{ position: "relative" }}
    >
      {item.icon && <img src={item.icon} />}
      <div className="info-select">
        <p
          className={values.length > 0 ? "label-select small" : "label-select"}
        >
          {item.label}
          {isRequired ? <b className="bold-asterix">*</b> : ""}
        </p>
        {values.length > 0 && (
          <p className="selection">
            {type && type === "date"
              ? values[0]
              : type === "textfield"
              ? values
              : formatSelections(values, item.options)}
          </p>
        )}
      </div>
    </div>
  );
};

export default InfoBarSelection;
